import {
  getPriorityMappingList,
  getcategoryTemplate,
  getSubCategoryTemplate,
  editcategoryTemplate,
  deletePriorityMappingList,
  getViewPriorityMappingList,
  updateSubCategoryData,
  createNewSubCategory,
} from "@/http/setup/priorityMapping.js";

export default {
  namespaced: true,
  state: {
    priorityMappings: [],
    categoryTemplate: [],
    subCategoryTemplate: {},
    editCategoryTemplate: {},
    viewPriorityMappings: {},
  },
  actions: {
    async fetchPriorityMappingList({ commit }) {
      try {
        const res = await getPriorityMappingList();
        commit("SET_PRIORITY_MAPPING_LIST", res.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchViewPriorityMappingList({ commit }, id) {
      try {
        const res = await getViewPriorityMappingList(id);
        commit("SET_VIEW_PRIORITY_MAPPING_LIST", res.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchEditCategoryTemplate({ commit }, id) {
      try {
        let res = await editcategoryTemplate(id);
        commit("EDIT_PRIORITY_MAPPING_TEMPLATE", res.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchCategoryTemplate({ commit }, id) {
      try {
        let res = await getcategoryTemplate(id);
        commit("SET_PRIORITY_MAPPING_TEMPLATE", res.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchsubCategoryTemplate({ commit }) {
      try {
        let res = await getSubCategoryTemplate();
        commit("SET_PRIORITY_MAPPING_TEMPLATES", res.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deletePriorityMappingAction({ commit }, id) {
      try {
        let res = await deletePriorityMappingList(id);
        commit("RESET_PRIORITY_MAPPING_LIST", id);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateSubCategory({commit}, {id, payload}) {
      try {
        let res = await updateSubCategoryData(id, payload);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createNewSubCategory(_, payload) {
      try {
        let res = await createNewSubCategory(payload);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    SET_PRIORITY_MAPPING_TEMPLATE(state, payload) {
      state.categoryTemplate = payload;
    },
    EDIT_PRIORITY_MAPPING_TEMPLATE(state, payload) {
      state.editCategoryTemplate = payload;
    },
    SET_PRIORITY_MAPPING_TEMPLATES(state, payload) {
      state.subCategoryTemplate = payload;
    },
    SET_PRIORITY_MAPPING_LIST(state, payload) {
      state.priorityMappings = payload;
    },
    SET_VIEW_PRIORITY_MAPPING_LIST(state, payload) {
      state.viewPriorityMappings = payload;
    },
    RESET_PRIORITY_MAPPING_LIST(state, id) {
      state.priorityMappings = state.priorityMappings.filter(
        (el) => el.id !== id
      );
    },
  },
};
